<template>
    <div class="contact">
    <p class="title has-text-weight-light has-text-left">CONTACT</p>
    <div class="content has-text-left">
        <h2 class="subtitle has-text-weight-light">email adress</h2>
        <p>入部希望、音楽制作についての質問、要望等何かご用があれば<strong>to_con_create@yahoo.co.jp</strong>
            <br>またはtwitterID <a href="https://twitter.com/toconcreate"><strong>@toconcreate</strong></a>まで、気軽に連絡してください!</p>
        <br>
    </div>
    </div>
</template>

<script>
    export default {
        name: "CONTACT"
    }
</script>

<style scoped>
    .title{
        font-size: 45px;
    }
    .content{
        margin-top: 50px;
        margin-left: 20px;
    }
    p{
        font-size:14px;
        margin-bottom:24px;
        line-height:1.75;
        text-align:justify;
        letter-spacing:1px;
        font-feature-settings: "pkna";
        margin-right: 10px;
    }
    .subtitle{
        margin-bottom: 10px;
        padding-bottom: 0;
        font-size: 24px;
        font-weight: bolder;
    }
</style>